/* repo/receipt*/
import {
  drop as dropApi,
  fetch as fetchApi, insert as insertApi,
  isString,
} from "./api";
import { ReceiptCodec, Receipt, Data } from "../store/receipt/types";
import { withDecoded, flattenData } from "./";

function mapToModel(data: object): Receipt {
  return withDecoded(ReceiptCodec, data, (decoded) => ({
    ...decoded,
  }));
}

export async function fetch(id: string | null, params?: {}): Promise<Receipt> {
  return fetchApi({
    nestedResourcePath: ["receipt"],
    id: id,
    params: params,
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function save(receipt: Data): Promise<Receipt> {
  return insertApi({
    nestedResourcePath: ["receipt"],
    id: receipt.id,
    data: { data: receipt },
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function drop(id: string | null): Promise<boolean> {
  return dropApi({
    nestedResourcePath: ["receipt"],
    id: id,
  }).then(() => true);
}
